import React, { useContext, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import fb from 'firebaseConfig';
import { AuthContext } from 'providers/AuthProvider';

import PATH from 'routes/path';

const PublicRoute = (props) => {
  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    window.Intercom('update', {
      hide_default_launcher: false,
    });
  }, []);

  const logout = () => {
    if (localStorage.getItem('webview')) {
      localStorage.clear();
      localStorage.setItem('webview', 'true');
    } else {
      localStorage.clear();
    }
    fb.auth().signOut();
  };

  /* VERIFICA SE ESTAMOS EM MANUTENÇÃO */
  if (process.env.REACT_APP_MAINTENANCE === 'true') {
    if (currentUser) logout();
    return (
      <Redirect to={PATH.MAINTENANCE} />
    );
  }

  // Redireciona para página inicial (se logado)
  if (currentUser) {
    return (
      <Redirect to={PATH.HOME} />
    );
  }

  return (
    <Route {...props} />
  );
};

export default PublicRoute;
